
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { usePerformanceYear } from "@/contexts/PerformanceYearContext";

export const useBandDisagreementsState = () => {
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [isUnitHead, setIsUnitHead] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("personal-goals");
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [isRecordsExpanded, setIsRecordsExpanded] = useState(true);
  const [resolutionOutcome, setResolutionOutcome] = useState("");
  const [resolutionNotes, setResolutionNotes] = useState("");
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);
  const { activeYear } = usePerformanceYear();

  const checkUserStatus = async () => {
    setIsLoading(true);
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError || !user) {
        console.error("Error getting user:", userError);
        setIsLoading(false);
        return;
      }

      setCurrentUserId(user.id);

      // Check if user is a supervisor
      const { data: teamMembers, error: supervisorError } = await supabase
        .from('users')
        .select('id')
        .eq('supervisor_id', user.id)
        .limit(1);

      if (supervisorError) {
        console.error("Error checking supervisor status:", supervisorError);
      } else {
        setIsSupervisor(teamMembers && teamMembers.length > 0 || false);
      }

      // Check if user is a unit head
      const { data: userData, error: unitHeadError } = await supabase
        .from('users')
        .select('is_unit_head')
        .eq('id', user.id)
        .single();

      if (unitHeadError) {
        console.error("Error checking unit head status:", unitHeadError);
        setIsUnitHead(false);
      } else {
        setIsUnitHead(userData?.is_unit_head || false);
      }
    } catch (error) {
      console.error("Error checking user status:", error);
      setIsSupervisor(false);
      setIsUnitHead(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkUserStatus();
  }, [activeYear]);

  useEffect(() => {
    if (selectedRecord) {
      setResolutionOutcome(selectedRecord.resolution_outcome || '');
      setResolutionNotes(selectedRecord.resolution_notes || '');
    }
  }, [selectedRecord]);

  return {
    isSupervisor,
    isUnitHead,
    isLoading,
    activeTab,
    setActiveTab,
    selectedRecord,
    setSelectedRecord,
    isRecordsExpanded,
    setIsRecordsExpanded,
    resolutionOutcome,
    setResolutionOutcome,
    resolutionNotes,
    setResolutionNotes,
    currentUserId,
    activeYear
  };
};
